export default {
  default: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/layouts/default.vue")
}